import React, { useState, useEffect } from "react";

export default function CountDown(props) {
  const [DateCount, setDateCount] = useState(0);

  const countDownDate = new Date(props.CountDate).getTime();

  var now = new Date().getTime();
  const distance = countDownDate - now;

  const days = Math.floor(distance / (1000 * 60 * 60 * 24));
  const hours = Math.floor(
    (distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
  );
  const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
  const seconds = Math.floor((distance % (1000 * 60)) / 1000);

  const date = days + "d " + hours + "h " + minutes + "m " + seconds + "s left";




 

  useEffect(() => {
    if(distance < 0){
      setDateCount("Expired:)")
    }
    const interval = setInterval(() => {
      setDateCount(date)
    }, 1000)
    return () => clearInterval(interval)
  })

  return <div>{DateCount}</div>;
}
